import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-cannibal-cluster-form',
  templateUrl: './seo-cannibal-cluster-form.component.html',
  styleUrls: ['./seo-cannibal-cluster-form.component.css'],
})
export class SeoCannibalClusterFormComponent implements OnInit {
  url: string = 'seoCannibalClusters';
  id!: string;
  cluster: any;

  resumenCards = [
    {
      label: 'Total clusters',
      value: '10',
      desc: 'Total clusters',
      bgClass: 'bg-warning',
      icon: 'content_copy',
      route: '/observability/seo/cannibalClusters',
    },
    {
      label: 'Total edges',
      value: '10',
      desc: 'Total edges',
      bgClass: 'bg-success',
      icon: 'content_copy',
      route: '/observability/seo/cannibalEdges',
    },
    {
      label: 'Total metrics',
      value: '10',
      desc: 'Total metrics',
      bgClass: 'bg-danger',
      icon: 'content_copy',
      route: '/observability/seo/metrics',
    },
    {
      label: 'Total actions',
      value: '10',
      desc: 'Total actions',
      bgClass: 'bg-info',
      icon: 'content_copy',
      route: '/observability/seo/actions',
    },
  ];

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.cluster = response;
    });
  }
}
